import { type Descendant, Node } from 'slate';

/**
 * Flatten a Slate document to plain text — used by the composer to
 * decide whether the user has authored anything send-worthy. Slate's
 * `Node.string` works recursively across blocks; we then trim each
 * top-level block and re-join with newlines so adjacent paragraphs
 * read naturally in plain form.
 *
 * Accepts Slate's own `Descendant[]` rather than the slice's
 * narrowed type so callers can pass `editor.children` directly
 * without intermediate casts.
 */
export function slateToPlainText(nodes: Descendant[]): string {
  return nodes
    .map(node => Node.string(node))
    .filter(s => s.length > 0)
    .join('\n')
    .trim();
}
